import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import userThunk from 'src/store/client/thunks/userThunk';
import type { MEMBER_GRADE, USER_TYPE } from 'src/types/common.types';

type PrevSession = {
  conn_ip: string;
  os_info: string;
};

export type SSID = {
  expired: string;
  ssid: string;
};

export type UserAuth = {
  access_token: string;
  refresh_token: string;
  expired: string;
  token_type: string;
  last_pwd_dt: string;
  creator_flag: 'CON' | 'COFF';
  prev_session: PrevSession;
};

export type UserInfo = {
  // ma_mbr_key: string;
  mbr_id: string;
  mbr_nm: string;
  gender?: null | string;
  birth?: null | string;
  phone: string;
  foreigner?: null | 'Y' | 'N' | '';
  sns_type: USER_TYPE;
  nick_name: string;
  mem_grade: MEMBER_GRADE;
  // mbr_status?: string;
  profile_img: string;
  // reg_dttm?: string;
  // ad_agree_yn?: string;
  // push_email?: 'Y' | 'N';
  // push_sms?: 'Y' | 'N';
  // mem_level?: MEMBER_LEVEL;
  income_earner_yn?: 'Y' | 'N';
  // account_linking?: {
  //   google: 'Y' | 'N';
  //   kakao: 'Y' | 'N';
  // };
  employee_yn?: 'Y' | 'N';
};

export type UserState = {
  LoggedIn: boolean;
  userAuth: UserAuth | null;
  userInfo: UserInfo | null;
  prevSession: PrevSession | null;
  error?: unknown | null;
};

const initialState: UserState = {
  LoggedIn: false,
  userAuth: null,
  userInfo: null,
  prevSession: null,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    HYDRATE: (state, action: PayloadAction<UserState>) => {
      return { ...state, ...action.payload };
    },
    // setUserInfo: (state, action: PayloadAction<UserInfo>) => {
    //   state.userInfo = action.payload;
    // },
    // setAdAgreeSMS: (state, action: PayloadAction<{ push_sms: 'Y' | 'N' }>) => {
    //   if (state.userInfo) {
    //     state.userInfo.push_sms = action.payload.push_sms;
    //   }
    // },
    // setAdAgreeEmail: (state, action: PayloadAction<{ push_email: 'Y' | 'N' }>) => {
    //   if (state.userInfo) {
    //     state.userInfo.push_email = action.payload.push_email;
    //   }
    // },
    clearUserInfo: (state) => {
      state.userInfo = null;
    },
    login: (state, action: PayloadAction<UserAuth>) => {
      state.LoggedIn = true;
      state.userAuth = action.payload;
    },
    logout: (state) => {
      state.LoggedIn = false;
      state.userAuth = null;
      state.userInfo = null;
      state.prevSession = null;
      state.error = null;
    },
    prevSessionClear: (state) => {
      state.prevSession = null;
    },
  },
  extraReducers: (builder) => {
    const { myDataLoad, refreshTokenNew, refreshTokenAll } = userThunk;
    builder
      .addCase(myDataLoad.pending, (state) => {
        state.userInfo = null;
        state.error = null;
      })
      .addCase(myDataLoad.fulfilled, (state, action) => {
        state.userInfo = action.payload;
      })
      .addCase(myDataLoad.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(refreshTokenNew.pending, (state) => {
        state.error = null;
      })
      .addCase(refreshTokenNew.fulfilled, (state, action) => {
        state.LoggedIn = true;
        state.userAuth = action.payload;
        state.prevSession = action.payload?.prev_session;
      })
      .addCase(refreshTokenNew.rejected, (state, action) => {
        state.LoggedIn = false;
        state.userAuth = null;
        state.error = action.error;
      })
      .addCase(refreshTokenAll.pending, (state) => {
        state.error = null;
      })
      .addCase(refreshTokenAll.fulfilled, (state, action) => {
        state.LoggedIn = true;
        state.userAuth = action.payload;
      })
      .addCase(refreshTokenAll.rejected, (state, action) => {
        state.LoggedIn = false;
        state.userAuth = null;
        state.error = action.error;
      });
  },
});

export const userActions = userSlice.actions;

export default userSlice;

/*
export const setUserInfo = (userInfo) => ({ type: UserActionTypes.SetUserInfo, value: { ...userInfo } });
export const clearUserInfo = () => ({ type: UserActionTypes.ClearUserInfo });
export const fnLogin = (user) => ({ type: UserActionTypes.LoggedinUser, value: { ...user } });
export const fnLogout = () => ({ type: UserActionTypes.LogOut });
export const fnPrevSessionClear = () => ({ type: UserActionTypes.PREV_SESSION_CLEAR });

import { userActions } from 'src/store/slices/userSlice';

import { userActions } from 'src/store/slices/userSlice';
*/
